<template>
    <div class="about_menu_top  textalign_left">
        <div class="max_width">
            <div class="about_title" ref="aboutfishqc">{{$t('about.fishqc')}}</div>
            <div class="about_content" v-html="$t('about.totaldesc1')"></div>
            <div class="about_content1">{{$t('about.subtitle')}}</div>
            <div class="display_flex  justify-content_flex-justify" style="padding:20px 0 64px;">
                <div class="about_introduct">
                    <div class="height_200 textalign_center">
                        <img src="http://p1.fishqc.net/FgDCvIMQI5aRQ3rU0STU-1S2j94b" alt="" class="about_introduct_img1">
                        <div><span class="about_introduct_txt1 vertical-middle">100,000</span><span class="about_add vertical-middle">＋</span></div>
                    </div>
                    <div class="padding_30">{{$t('about.substatus1')}}</div>
                </div>
                <div class="about_introduct">
                    <div class="height_200 textalign_center">
                        <img src="http://p1.fishqc.net/Fn0j9a_4MVCP6jTXJtTm9RG5SB-y" alt="" class="about_introduct_img2">
                    </div>
                    <div class="padding_30">{{$t('about.substatus2')}}</div>
                </div>
                <div class="about_introduct">
                    <div class="height_200 textalign_center">
                        <img src="http://p1.fishqc.net/Fl0AEMGnph0gVOg0se9T0n-ebJ1m" alt="" class="about_introduct_img3">
                    </div>
                    <div class="padding_30">{{$t('about.substatus3')}}</div>
                </div>
                <div class="about_introduct">
                    <div class="height_200 textalign_center">
                        <img src="http://p1.fishqc.net/Fmgf2wThn9_rgbh92slwHNLsTt3V" alt="" class="about_introduct_img4">
                    </div>
                    <div class="padding_30">{{$t('about.substatus4')}}</div>
                </div>
            </div>
        </div>
        <div class="background_blue">
            <div class="max_width">
                <div class="padding_64">
                    <div class="about_stand_title1" ref="technology">{{$t('about.fishqcstandard')}}</div>
                    <div class="about_stand_content">{{$t('about.fishqcstandarddesc')}}</div>
                    <div class="about_box">
                        <div class="title">{{$t('about.qingjiangyu')}}</div>
                        <div class="display_flex  justify-content_flex-justify">
                            <div class="d" v-html="$t('about.qingjiangyudesc')">
                            </div>
                            <div>
                                <img :src="$t('about.techImg1')" class="width_500">
                            </div>
                        </div>
                    </div>
                    <div class="about_box">
                        <div class="title">{{$t('about.banmayu')}}</div>
                        <div class="display_flex  justify-content_flex-justify">
                            <div class="d" v-html="$t('about.banmayudesc')">
                            </div>
                            <div>
                                <img :src="$t('about.techImg2')" class="width_500">
                            </div>
                        </div>
                    </div>
                    <div class="about_box">
                        <div class="title">{{$t('about.chengfen')}}</div>
                        <div class="display_flex  justify-content_flex-justify">
                            <div class="d" v-html="$t('about.chengfendesc')">
                            </div>
                            <div class="padding_top_60">
                                <img src="http://p1.fishqc.net/FjhWQjYH02tLsradxTT7rd4Jrt9N">
                            </div>
                        </div>
                    </div>
                    <div class="about_box fishblock" v-for="item in fishdata">
                        <div class="display_flex  justify-content_flex-justify align-items_center about_fish_relative">
                            <div>
                                <div>
                                    <span class="about_fish vertical-middle">{{item.type}}</span><span  v-bind:class="['about_fish_label','vertical-middle',item.labelstyle]">{{item.label}}</span>
                                </div>
                                <div class="d">
                                    <div v-html="item.desc"></div>
                                </div>
                            </div>
                            <div  v-bind:class="['about_fish_rightbox',item.rightboxColor]">
                                <img :src="item.fishImg" alt="" class="fishImgStyle" >
                                <div class="about_fish_innerbox">
                                    <div class="about_fish_center">
                                        <ul :class="{'about_tips_right':currentlang == 'eng'}">
                                            <li >
                                                <span class="vertical-middle">{{$t('about.manxi')}}</span>
                                                <img :src="item.icon_ji" class="about_fish_icon">

                                            </li>
                                            <li>
                                                <span class="vertical-middle">{{$t('about.jixing')}}</span>
                                                <img :src="item.icon_man" class="about_fish_icon">
                                            </li>
                                            <li>
                                                <span class="vertical-middle">{{$t('about.chengfen')}}</span>
                                                <img :src="item.icon_chengfen" class="about_fish_icon">
                                            </li>
                                        </ul>
                                        <div class="fish_test">{{item.label}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-bind:class="['fixback',item.backgroundColor]"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="backgroundColor_green">
            <div class="max_width about_develop">
                <div class="about_develop_title">{{$t('about.develop')}}</div>
                <div class="about_develop_intro">{{$t('about.developdesc')}}</div>
            </div>
        </div>
        <div class="max_width padding_bottom_64">
            <div class="about_title" >{{$t('about.fishqc_support')}}</div>
            <div class="about_content">{{$t('about.supportdesc')}}</div>
            <div class="about_technogoly display_flex  justify-content_flex-justify align-items_center">
                <div class="about_tech_left">
                    <div class="title">{{$t('about.vartagent')}}</div>
                    <div class="content">{{$t('about.vartagentdesc')}}</div>
                </div>
                <div class="position_relative flex_1">
                    <img src="http://p1.fishqc.net/FrsqbStqwcxW7hT1OQ8wA-eGNtMp" alt="" class="zhanwei">
                </div>
            </div>
            <div class="about_technogoly display_flex  justify-content_flex-justify align-items_center">
                <div class="position_relative flex_1">
                    <img src="http://p1.fishqc.net/Fjo3RebNSBh7orU6-tBPFjQSqjeW" alt="" class="prizeimg1">
                </div>
                <div class="about_tech_right">
                    <div class="title padding_top_74">{{$t('about.fishqc_prize')}}</div>
                    <div class="content padding_bottom_108">{{$t('about.prizedesc')}}</div>
                </div>
                
            </div>
            <div class="about_technogoly display_flex  justify-content_flex-justify align-items_center">
                <div class="about_tech_left">
                    <div class="title padding_top_74">{{$t('about.fishqc_testing')}}</div>
                    <div class="content">{{$t('about.testingdesc')}}</div>
                </div>
                <div class="position_relative flex_1">
                    <img src="http://p1.fishqc.net/Fi9TIrS_F47XDOQapp5yQ35iyg2d" alt="" class="zhanwei">
                </div>
            </div>
            <div class="about_technogoly display_flex  justify-content_flex-justify">
                <div class="position_relative flex_1 powerbox" >
                    <div class="display_flex flex-wrap_wrap">
                        <div class="textalign_center poweritem" v-for="item in powerdata">
                            <img :src="item.img">
                            <div class="power_title">{{item.title}}</div>
                            <div class="power_address">{{item.address}}</div>
                        </div>
                    </div>
                    <div class="">
                        <div class="textalign_center poweritem" v-for="item in powerdata1">
                            <img :src="item.img">
                            <div class="power_title">{{item.title}}</div>
                            <div class="power_address">{{item.address}}</div>
                        </div>
                    </div>
                </div>
                <div class="about_tech_right">
                    <div class="title padding_top_74">{{$t('about.power')}}</div>
                    <div class="content padding_bottom_245">{{$t('about.powerdesc')}}</div>
                </div>
                
            </div>

        </div>
        <div  v-bind:class="[item.backgroundColor]" class="" v-for="item in fishqcTeam">
            <div class="max_width padding_bottom_64">
                <div class="about_title">{{item.title}}</div>
                <div class="display_flex  flex-wrap_wrap textalign_center">
                    <div v-for="value in item.teamArr" class="test">
                        <div>
                            <img :src="value.headImg" alt=""  class="fishcTeamerImg">
                        </div>
                        <div class="name">{{value.name}}</div>
                        <div class="title">{{value.title}}</div>
                        <div v-html="value.degree" class="degree"></div>
                    </div>
                </div>
            </div>
        </div>

        <div  v-bind:class="[item.backgroundColor]" class="" v-for="item in fishqcPrize">
            <div class="max_width padding_bottom_64">
                <div class="about_title">{{item.title}}</div>
                <div class="display_flex  flex-wrap_wrap textalign_center">
                    <div v-for="value in item.teamArr" class="test test1">
                        <div class="prizebox" v-bind:class="[value.prizeboxstyle]">
                            <img :src="value.headImg" alt=""  class="fishcPrizeImg">
                        </div>
                        <div class="title" v-if="currentlang !='eng'">{{value.name}}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="background_white" v-if="currentlang !='eng'">
            <div class="max_width padding_bottom_64">
                <div class="about_title">{{$t('about.fishqc_bigthing')}}</div>
                <div class="item" v-for="item in fishqcthings">
                    <div class="item-line"></div>
                    <div v-bind:class="['item-line-bottom']"></div>
                    <div class="title">{{item.time}}</div>
                    <div class="flag">
                        <div v-bind:class="['circle']" ></div>
                    </div>
                    <div class="data">
                        <div class="desc">{{item.thing}}</div>
                    </div>
                </div>
                
            </div>
        </div>
        <div class="background_contact">
            <div class="max_width padding_bottom_64 display_flex justify-content_flex-justify">
                <div>
                    <div class="about_contact" ref="contact">{{$t('about.contact_title')}}</div>
                    <div class="contact_detail">
                        <div class="fishqc_address"><span class="address_left">{{$t('about.contact_office')}}</span>丨 {{$t('about.contact_address')}}  </div>
                        <div class="fishqc_address"><span class="address_left">{{$t('about.contact_lab')}}</span> 丨 {{$t('about.contact_labaddress')}}</div>
                        <div class="fishqc_address margin_top_26">
                            <span class="address_left">{{$t('about.contact_phone')}}</span>  <div> 丨 {{$t('about.contact_lab')}}：(+852) 2393-2343 </div>
                            <div class="padding_left_fix">{{$t('about.contact_office')}}：(+852) 2393-2377</div>
                        </div>
                        
                    </div>
                </div>
                <div>
                    <img src="http://p1.fishqc.net/FuACtGnUda9Nu7ql7rhFGu4ayDTy" alt="" class="margin_right_40">
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.test{
    width: 25%;
    padding:32px 0 0;
    // height: 300px;
    // background-color: #ddd;
    // margin-right: 40px;
    &:nth-of-type(2n){
        // background-color:pink;
    }
    &:nth-of-type(4n){
        margin-right: 0px;
    }

    .fishcTeamerImg{
        @include wh(208px,208px);
        margin-bottom: 18px;
        border-radius: 50%;
        background: #eee;
    }

    .fishcPrizeImg{
        @include center;
        // @include wh(208px,208px);
        // margin-bottom: 18px;
        // background: #eee;
    }
    .name{ 
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262633;
        line-height: 24px;
    }

    .title{
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 24px;
        padding:8px 0;
    }

    .degree{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262633;
        line-height: 24px;
        padding:0 12px;
    }
}

.test1{
    width: 20%;
    padding:12px 0 0;
    &:nth-of-type(1){
        padding-top: 0;
    }
    &:nth-of-type(2){
        padding-top: 0;
    }
    &:nth-of-type(3){
        padding-top: 0;
    }
    &:nth-of-type(4){
        padding-top: 0;
    }
    &:nth-of-type(5){
        padding-top: 0;
    }
    .prizebox{
        width:221px;
        height: 160px;
        border:1px solid #E9E9E9;
        position: relative;
        vertical-align: top;
        background-color: #fff;
        &.noborder{
            border:none;
        }
    }
}
.about_menu_top {
    margin: 100px auto 0;

}

.max_width {
    width: $pageWidth;
    margin: 0 auto;
}

.padding_64 {
    padding: 64px 0;
    box-sizing: border-box;
}

.padding_bottom_64{
    padding-bottom: 64px;
    box-sizing: border-box;
}

.about_title {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262633;
    line-height: 32px;
    padding-top: 32px;
    box-sizing: border-box;
    padding-bottom: 32px;
}

.about_content {
    font-size: 16px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #51515C;
    line-height: 32px;
    padding: 16px 0;
    box-sizing: border-box;
    text-align: justify;
}

.about_content1 {
    font-size: 20px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #262633;
    line-height: 40px;
    text-align: justify;
}

.about_introduct {
    width: 282px;
    padding-bottom: 10px;
    box-sizing: border-box;
    // height: 402px;
    background: #FFFFFF;
    box-shadow: 0 0px 15px 0 rgba(233, 233, 235, 0.3);
    .about_introduct_img1{
        padding:22px 0 12px;
        box-sizing: border-box;
    }
    .about_introduct_img2{
        padding:19px 66px 0;
        box-sizing: border-box;
    }
    .about_introduct_img3{
        padding:8px 36px 0 27px;
        box-sizing: border-box;
    }

    .about_introduct_img4{
        padding:12px 38px 0 52px;
        box-sizing: border-box;
    }
    .about_introduct_txt1{
        font-size: 31px;
        font-family: HiraKakuStd-W8, HiraKakuStd;
        font-weight: normal;
        color: #60DEB4;
    }

    .about_add{

        font-size: 17px;
        font-family: HiraKakuStd-W8, HiraKakuStd;
        font-weight: normal;
        color: #60DEB4;
    }
}

.height_200 {
    height: 202px;
}

.padding_30 {
    padding: 0 30px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
    text-align: justify;
}

.background_blue {
    background-color: #F8FBFD;
}
.background_white {
    background-color: #FFF;
}
.about_stand_title1 {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262633;
    line-height: 32px;

}

.about_stand_content {
    padding-top: 16px;
    font-size: 16px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #51515C;
    line-height: 32px;
}

.about_box {
    margin-top: 24px;
    width: 1200px;
    padding: 24px 24px 36px;
    box-sizing: border-box;
    background: #fff;
    box-shadow: 0 4px 10px 0 #E9E9EB;
    position: relative;
    overflow: hidden;
    text-align: justify;
    .fixback{
        position: absolute;
        left: -220px;
        bottom: -878px;
        width: 1000px;
        height: 1000px;
        border-radius: 45%;
        background: #E0FFFE;
    }
    .about_fish_relative {
        z-index: 2;
        position: relative;
    }

    .title {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262633;
        line-height: 32px;
    }

    .about_fish {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262633;
        line-height: 32px;
    }

    .about_fish_label {
        width: 112px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        background: #E0FFED;
        border-radius: 6px;
        border: 1px solid #60DEB4;
        display: inline-block;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4DA8A4;
        margin-left: 14px;
        &.green{
            background: #E0FFED;
            border: 1px solid #60DEB4;
            color: #4DA8A4;
        }
        &.yellow{
            color: #FFC72F;
            
            background: #FFFAE1;
            border: 1px solid #FFDF45;
        }

        &.red{
            background: #FFF4EF;
            border: 1px solid #FF8437;
            color: #FF8437;
        }
    }

    .about_fish_rightbox {
        width: 228px;
        height: 220px;
        background: #60DEB4;
        border-radius: 16px;
        padding: 12px 14px;
        box-sizing: border-box;
        text-align: center;
        position: relative;
        .fishImgStyle{
            position: absolute;
            left:-166px;
            top:50%;
            transform: translate(0,-50%);
            z-index: 2
        }
        &.green{
            background:#60DEB4;
        }
        &.yellow{
            background:#FFDB69;
        }

        &.red{
            background:#FF8437;
        }
        .about_fish_innerbox {
            height: 194px;
            border-radius: 16px;
            border: 1px dashed rgba(236, 255, 239, 0.5);
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 28px;
            position: relative;

            .fish_test {
                font-size: 22px;
                font-weight: 500;
                border-top: 2px solid rgba(147,147,147,.1);
                display: inline-block;
                padding: 8px 16px 0;
                margin-top: 12px;
            }

            .about_fish_center {
                width: 100%;
                @include center;
            }

            .about_fish_icon{
                width: 16px;
                height: 16px;
                vertical-align: middle;
                margin-left: 6px;
            }
        }
    }

    .background_green{
        background: #E0FFFE;
    }

    .background_yellow{
        background: #FFFAE1;
    }

    .background_red{
        background:#FFF4EF;
    }
}

.d {
    width: 652px;
    padding: 16px 0 0px;
    font-size: 14px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
}

.backgroundColor_green{
    // background: #49DAAA;
    @include bis('http://p1.fishqc.net/FqcGdDndLl-AX1ajT2UmgU__fl7f');
    .about_develop{
        padding:64px 0 54px;
        box-sizing: border-box;
        text-align: center;
        .about_develop_title{

            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 32px;
            text-shadow: 0px 2px 4px #40D1A1;
        }
        .about_develop_intro{
            font-size: 18px;
            font-family: PingFang-SC-Regular, PingFang-SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 36px;
            text-shadow: 0px 2px 10px #30CE9A;
            padding-top: 14px;
            box-sizing: border-box;
        }
    }
}

.about_technogoly{
    margin-top: 24px;
    width: 1200px;
    border:1px solid #F4F4F5;
    background: #fff;
    position: relative;
    overflow: hidden;
    .prizeimg1{
        padding:26px 116px 0 78px;
        box-sizing: border-box;
    }
    .title{
        padding:24px 0 16px;
        box-sizing: border-box;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262633;
        line-height: 32px;
    }
    .content{
        font-size: 14px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
        padding-bottom:34px;
        box-sizing: border-box;
        text-align: justify;
    }
    .about_tech_left{
        padding-left: 50px;
        box-sizing: border-box;
        width:526px;
    }

    .about_tech_right{
        padding-right: 48px;
        box-sizing: border-box;
        width:575px;
        .content{
            width: 525px;
        }
        
    }
    .zhanwei{
        @include center;
    }

    .padding_top_74{
        padding-top: 74px;
        box-sizing: border-box;
    }

    .padding_bottom_108{
        padding-bottom: 108px;
        box-sizing: border-box;
    }

    .padding_bottom_245{
        padding-bottom:245px;
        box-sizing: border-box;
    }

    .poweritem{
        margin:0 24px 0 0;
    }

    .powerbox{
        padding:40px 0 0 48px;
        box-sizing:border-box;
        .power_title{
            padding-top: 4px;
            box-sizing: border-box;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #262633;
            line-height: 22px;
        }
        .power_address{
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #51515C;
            line-height: 20px;
            margin-bottom: 16px;
        }
    }
}

.padding_top_60{
    padding-top: 60px;
    padding-left: 7px;
    box-sizing: border-box;
}

.item {
    width: 60%;
    position: relative;
    display: flex;
    box-sizing: border-box;
    margin:0 auto 24px;
}

.item .item-line {
    content: '';
    position: absolute;
    top: 10px;
    left:121px;
    width: 2px;
    height: 100%;
    // background: rgba(244,244,245,0.7);
    background-color: #F4F4F5;
    box-sizing: border-box;
    z-index: 2;
    display: inline-block;
}

.item .item-line-bottom {
    content: '';
    position: absolute;
    top: 100%;
    left: 121px;
    width: 2px;
    height: 24px;
    // background: rgba(244,244,245,0.7);
    background-color: #F4F4F5;
    z-index: 2;
    display: inline-block;
}

.item .flag {
    position: relative;
    width: 14px;
    z-index: 3;
    left:8px;
}

.item .flag .circle {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: linear-gradient(270deg, #28D877 0%, #0DC6B8 100%);
    display: inline-block;
}

.item .data {
    width: 100%;
    padding-left: 44px;
    box-sizing: border-box;
}

.item .data .desc {
    font-size: 14px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
    margin-top: -7px;
    text-align: justify;
}

.item  .title {
    display: inline-block;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #A8A8AD;
    line-height: 32px;
        width: 120px;
    text-align: right;
    margin-top: -7px;
    margin-right: 8px;
}

.background_contact{
    padding-top: 72px;
    background-image: url('http://p1.fishqc.net/FpMEB2Whm5AbhSkX4etRjIO-C2Qy');
    background-repeat: no-repeat;
    background-size: 100% 100%;
}
.about_contact{
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 45px;
    padding-bottom: 48px;
    box-sizing: border-box;
}
.margin_right_40{
    margin-right: 40px;
}

.contact_detail{

    font-size: 14px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 26px;
}
.fishqc_address{
    padding-left: 60px;
    box-sizing: border-box;
    position: relative;
    font-size: 14px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 26px;
    &.margin_top_26{
        margin-top: 26px;
    }
    .address_left{
        position: absolute;
        left:0;
        top:0;
    }

    .padding_left_fix{
        padding-left: 18px;
    }
}

.about_tips_right{
    text-align: right;
    padding-right: 10px;
    box-sizing: border-box;
}

.width_500{
    width: 480px;
}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { myMixin } from '@/mixin/mixin.js'
export default {
    name: 'about',
    components: {
        banner,
    },
    mixins: [myMixin],
    data() {
        return {
            swiperOptions: {
                pagination: {
                    el: '.swiper-pagination1'
                },
                uniqueNavElements: false,

                // Some Swiper option/callback...
            },
            fishdata:{
                绿色小鱼:{
                    type:this.$t('about.greenfish'),
                    label:this.$t('about.green_excellent'),
                    desc:this.$t('about.greendesc1'),
                    backgroundColor:'background_green',
                    labelstyle:'green',
                    rightboxColor:'green',
                    fishImg:'http://p1.fishqc.net/FvStV-oV8Ap_v69AfvIn8Mkwifgc',
                    icon_ji:'http://p1.fishqc.net/FpSN6pd8J34q0Ihp4eTWyM7zKzfS',
                    icon_man:'http://p1.fishqc.net/FpSN6pd8J34q0Ihp4eTWyM7zKzfS',
                    icon_chengfen:'http://p1.fishqc.net/FpSN6pd8J34q0Ihp4eTWyM7zKzfS'
                },
                黄色小鱼 :{
                    type:this.$t('about.yellowfish'),
                    label:this.$t('about.yellow_pass'),
                    desc:this.$t('about.yellowdesc1'),
                    backgroundColor:'background_yellow',
                    labelstyle:'yellow',
                    rightboxColor:'yellow',
                    fishImg:'http://p1.fishqc.net/Fv9TsEGAlM-MV5YfcDzrFiBz2E72',
                    icon_ji:'http://p1.fishqc.net/FpSN6pd8J34q0Ihp4eTWyM7zKzfS',
                    icon_man:'http://p1.fishqc.net/FuQXzlHHMQLX4R8bIzRwlZ4YbfQk',
                    icon_chengfen:'http://p1.fishqc.net/FuQXzlHHMQLX4R8bIzRwlZ4YbfQk'
                },
                红色小鱼:{
                    type:this.$t('about.redfish'),
                    label:this.$t('about.red_nopass'),
                    desc:this.$t('about.reddesc1'),
                    backgroundColor:'background_red',
                    labelstyle:'red',
                    rightboxColor:'red',
                    fishImg:'http://p1.fishqc.net/FtbvuAub4AcuDZl_ylVaoGvimX6Q',
                    icon_ji:'http://p1.fishqc.net/Fp-Q43GxN97enVphOM7__Awv7Ym9',
                    icon_man:'http://p1.fishqc.net/Fp-Q43GxN97enVphOM7__Awv7Ym9',
                    icon_chengfen:'http://p1.fishqc.net/Fp-Q43GxN97enVphOM7__Awv7Ym9'
                }
            },
            // fishqcTeam:{
            //     '小鱼团队':{
            //         title:'小鱼团队',
            //         backgroundColor:'background_blue',
            //         teamArr:[
            //             {
            //                 headImg:'http://p1.fishqc.net/Fj4wqY2a9oOvBDr7xjILhqIEVnWq',
            //                 name:'杜伟樑先生',
            //                 title:'首席执行官',
            //                 degree:"曼彻斯特理工大学学位<br>剑桥大学工程硕士学位"
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FslKD0Agkpjz0zCRdfAFdkaAGath',
            //                 name:'陈子翔先生',
            //                 title:'首席商务官',
            //                 degree:'香港城市大学学士，香港大学硕士，首届福<br>布斯亚洲“30位30岁以下的商业领袖' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FgTz07e6pTd9yqtqqahFK3gLlOI0',
            //                 name:'章子豪先生',
            //                 title:'财务总监',
            //                 degree:'美国宾夕法尼亚大学沃顿商学院与工学院双<br>学士,天使投资者' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/Fn2_qc42B-r3NcECG6sgH4BnBsh8',
            //                 name:'陈雪平博士',
            //                 title:'首席技术官',
            //                 degree:'香港城市大学博士，转基因发光鱼发明者,<br>欧洲注册毒理学家(ERT)' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FhtDFUqLEAOYXDthbu80nIiRvxpg',
            //                 name:'刘宇环先生',
            //                 title:'主席',
            //                 degree:'美商中经合集团创办人兼董事长美国百人会<br>会员，玉山科技协会创办人' 
            //             }
            //         ]
            //     },
            //     '管理顾问团队':{
            //         title:'管理顾问团队',
            //         backgroundColor:'background_white',
            //         teamArr:[
            //             {
            //                 headImg:'http://p1.fishqc.net/FkdW_DkKOcEsL_DCSX_aq03sPTqI',
            //                 name:'郭位教授',
            //                 title:'顾问',
            //                 degree:"香港城市大学校长,美国国家工程院院士、<br>台湾中央研究院院士、中国工程院外籍院士<br>及俄罗斯工程院外籍院士"
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FqJNtgJDvqfduCH4FCPDG5qrJSa2',
            //                 name:'叶正光先生',
            //                 title:'顾问',
            //                 degree:'叶挺将军之子,六合集团董事长,中国中央企<br>业中国节能环保集团六合天融环保科技有限<br>公司创办人，Global Zone International Limited董事长' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FhU_fZuosOqyY31XE8kycjujw2uu',
            //                 name:'钟志平教授',
            //                 title:'顾问',
            //                 degree:'创科实业创办人(香港股票代码：0669)，<br>香港工业总会副主席,香港理工大学校董会<br>副主席' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FpCyC_hwbjAz6PRZXjygyrLyBo5E',
            //                 name:'Ms Annette Schömmel',
            //                 title:'顾问',
            //                 degree:'Babaluba Industrial Group 的创办人与董<br>事总经理,全球500强企业Kuoni（瑞士旅游<br>集团胜景游）董事会董事，德国1998年<br>年度企业家' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FrbR_7pht2O3gInp3EqTaOs-Ye-y',
            //                 name:'赵子翘先生',
            //                 title:'顾问',
            //                 degree:'创奇思的创办人及行政总裁,香港知名的高<br>科技企业家' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FjNKLsYv9jMiroOCESwYBGBVgNqn',
            //                 name:'Mr Björn Segerblom',
            //                 title:'顾问',
            //                 degree:'SGS前区域首席执行官15年' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FsMJXZ2Q8nvYOCegQDka9QeH_w_w',
            //                 name:'谭文康先生',
            //                 title:'顾问',
            //                 degree:'谭文康先生拥有多年投资银行经验,多家金<br>融集团（霸菱、中银国际、瑞士银行，富瑞<br>金融集团）企业担任要职亚洲协会「亚洲21<br>年轻领袖」，澳洲会计师公会「首40名年<br>轻商业领袖」' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FieNsSB09xziEVqiR7xW_ZFVloHF',
            //                 name:'沈锐华教授',
            //                 title:'顾问',
            //                 degree:'连续创业家、 连续社会企业家、 世界厕<br>所组织(WTO)创始人、 创建联合国11月19<br>日世界厕所日、 施瓦布世界经济论坛学院<br>院士、 阿育王全球伙伴、 2008时代杂志<br>环境英雄、 新加坡国立大学李光耀公共政<br>策学院教授、 专门从事扶贫运动。' 
            //             }
            //         ]
            //     },
            //     '国际科学顾问团队':{
            //         title:'国际科学顾问团队',
            //         backgroundColor:'background_blue',
            //         teamArr:[
            //             {
            //                 headImg:'http://p1.fishqc.net/FtRyjn4ApbJLGNXO6r3Gt-mxghB2',
            //                 name:'David Hinton教授',
            //                 title:'主席',
            //                 degree:"杜克大学环境科学与政策课环境质量<br>首席教授教授，环境质量专家"
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FsxTbgiwf8Hm43IF5-UpbiDGyCvS',
            //                 name:'郑淑娴教授',
            //                 title:'顾问',
            //                 degree:'香港城市大学生物科学系首席教授，<br>兽医学院副院长，转基因鲭鳉鱼技术<br>联合发明人' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FoQ0fanhtwm6L4LdZYsim3jHr_Jn',
            //                 name:'Thomas Braunbeck教授',
            //                 title:'顾问',
            //                 degree:'海德堡大学动物学水生生态学毒理学科主任,水产毒理学专家' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/Fr89QLb1uRlIH_MwZaZ_Y56gqncY',
            //                 name:'Ian Cotgreave教授',
            //                 title:'顾问',
            //                 degree:'卡罗林斯卡医学院毒理学系教授，<br>瑞典毒理学科研究中心战略科学发展部总监,<br>毒理学与化学品风险评估专家' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/Fml4UTOz1i4BgsJAhu8q0H5YAVF8',
            //                 name:'Daniel Schlenk教授',
            //                 title:'顾问',
            //                 degree:'加州大学水生态毒理学教授，<br>生态毒理学专家' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/Fqe_Q_iSI2o8iwYdKHvdSCDOhCGa',
            //                 name:'Masato Kinoshita博士',
            //                 title:'顾问',
            //                 degree:'京都大学应用生物科学教授，<br>应用生物学专家' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FuUjvFJAWbk-jgovMTboID9qACMI',
            //                 name:'宫知远教授',
            //                 title:'顾问',
            //                 degree:'新加坡国立大学生物科学系教授，<br>生物科学专家' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/Fo3m7PISFLJmmnif1funDOS32Zpm',
            //                 name:'Stefan Meyer博士',
            //                 title:'顾问',
            //                 degree:'洛桑理工学院综合食品和营养中心<br>运营总监，食品与营养学专家' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FkEyfhpBwqJGq493KzpGwpQTHhba',
            //                 name:'Peter de Witte教授',
            //                 title:'顾问',
            //                 degree:'比利时鲁汶大学制药和药理科学系主任，<br>药理学专家' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FrwPpMqCF6nzS_sclF_3yng5nCf0',
            //                 name:'Hani El-Nezami教授',
            //                 title:'顾问',
            //                 degree:'香港大学生物学系教授，食品毒理学专家' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FswcMo4RkWfI_Ax5LysPVoq0imly',
            //                 name:'黄港住教授',
            //                 title:'顾问',
            //                 degree:'香港浸会大学生物学系教授，香港政府<br>食品安全专家委员，食品安全专家' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FpIopOKe7hd4956GzYgbOoD-IKQ7',
            //                 name:'何建宗教授',
            //                 title:'顾问',
            //                 degree:'香港公开大学科学院院长，环境与水质专家' 
            //             }
            //         ]
            //     }
            // },
            fishqcTeam:this.$t("about.fishqcTeam"),
            // fishqcPrize:{
            //     '合作伙伴':{
            //         title:'合作伙伴',
            //         backgroundColor:'background_white',

            //         teamArr:[
            //             {
            //                 headImg:'http://p1.fishqc.net/Fh7VTFfKvIpEtDuxqPKCDUt5JUby',
            //                 name:'普华永道',
            //                 title:'',
            //                 degree:""
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FsLjLFFL04Bn2tnPf86xzdB5vzmO',
            //                 name:'中国检验认证集团',
            //                 title:'',
            //                 degree:'' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FuzwCy0jtieiZuNdhTzjL2bBEL0v',
            //                 name:'深圳市消费者委员会',
            //                 title:'',
            //                 degree:'' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FtW3qcPKs-E1s-gClJ2YKMHywfUM',
            //                 name:'美国麻省理工学院',
            //                 title:'',
            //                 degree:'' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FgpEjR9ERaEfSr3guVGTuB0DjTuw',
            //                 name:'中国毒理学会',
            //                 title:'',
            //                 degree:'' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/Frto7qgqf6DrgAYniNaNzH8PMl2S',
            //                 name:'比利时鲁汶大学',
            //                 title:'',
            //                 degree:'' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/Fs0WF6LSBOXRc5EvolvBgqnwVucY',
            //                 name:'香港大学',
            //                 title:'',
            //                 degree:'' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FjHkDXwXOHIFpYTgEF3dtLL0uEOs',
            //                 name:'香港城市大学',
            //                 title:'',
            //                 degree:'' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/Fivfhud4hYex9zXEOsLQog5yC3YN',
            //                 name:'台湾食品工業發展研究所',
            //                 title:'',
            //                 degree:'' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FogDNG33hNBsWl6n3gdkMlbIPFuw',
            //                 name:'广东省化妆品质量管理协会',
            //                 title:'',
            //                 degree:'' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FgX6VqELyPvh_z8s3iwtUqjNKAlv',
            //                 name:'中国疾病预防控制中心',
            //                 title:'',
            //                 degree:'' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/Fg30HQR_GwgPmyfY2FH_29nVekqO',
            //                 name:'世界绿色组织',
            //                 title:'',
            //                 degree:'' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FuMXfWpW9w2iONfN-11YOBjtdzJ4',
            //                 name:'南方都市报',
            //                 title:'',
            //                 degree:'' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/Fn-Yj7IqUqA_YmL7SVwaekMoYl79',
            //                 name:'上海日用化学品行业协会',
            //                 title:'',
            //                 degree:'' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FsPafGqnK44Cb_P5JWcVSBdxlgEi',
            //                 name:'英国皇家生物学会',
            //                 title:'',
            //                 degree:'' 
            //             },
                        
            //         ]
            //     },
            //     '部分奖项及荣誉':{
            //         title:'部分奖项及荣誉',
            //         backgroundColor:'background_blue',
            //         teamArr:[
            //             {
            //                 headImg:'http://p1.fishqc.net/Fh02N8E7_Fq26EltSqtbXfWNycdY',
            //                 prizeboxstyle:'noborder',
            //                 name:'',
            //                 title:'',
            //                 degree:""
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FjinpioLonYhGBfdaloGJaUY-_-I',
            //                 prizeboxstyle:'noborder',
            //                 name:'',
            //                 title:'',
            //                 degree:'' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FmbxL2zoMhmCUNBE37BMMBlNVfbX',
            //                 prizeboxstyle:'noborder',
            //                 name:'',
            //                 title:'',
            //                 degree:'' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/Fp2GwZ37e_zbuqoi_KuFiftD99Vp',
            //                 prizeboxstyle:'noborder',
            //                 name:'',
            //                 title:'',
            //                 degree:'' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/Fte9FYagDXyv7lazEZxd5EhUF3Zb',
            //                 prizeboxstyle:'noborder',
            //                 name:'',
            //                 title:'',
            //                 degree:'' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FtTKdZsYq1dapjQhsnd7VgZ9enQL',
            //                 prizeboxstyle:'noborder',
            //                 name:'',
            //                 title:'',
            //                 degree:'' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/Fuoev8bPOcVT7AV8gd_GuWWdXwZm',
            //                 prizeboxstyle:'noborder',
            //                 name:'',
            //                 title:'',
            //                 degree:'' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FlIjez_6xw45phvcY1byoK56Ixrv',
            //                 prizeboxstyle:'noborder',
            //                 name:'',
            //                 title:'',
            //                 degree:'' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FskOWY1kIGpaUQpWUGLYIKb9Ajhm',
            //                 prizeboxstyle:'noborder',
            //                 name:'',
            //                 title:'',
            //                 degree:'' 
            //             },
            //             {
            //                 headImg:'http://p1.fishqc.net/FiUbRrSuDVuzUno6O3UmXgLM7iRG',
            //                 prizeboxstyle:'noborder',
            //                 name:'',
            //                 title:'',
            //                 degree:'' 
            //             },
                        
                        
            //         ]
            //     },
                
            // },
            fishqcPrize:this.$t("about.fishqcPrize"),
            // fishqcthings:[
                
            //     {
            //         time:'11月20日',
            //         thing:'水中银小鱼亲测荣获由汇丰工商金融及《香港经济日报》合办的汇丰x 经济日报创新商业奖、创新中小企业金奖：奖品总值高达港币500,000元等值之 《香港经济日报》 广告宣传。上一年获得金奖的是香港历史最悠久的公用事业机构香港中华煤气有限公司。'
            //     },
            //     {
            //         time:'11月20日',
            //         thing:'由中国美妆网主办、抖盟协办2019中国美妆网红选品大会，水中银小鱼亲测受邀成为支持单位，并举办中国好配方比赛。'
            //     },
            //     {
            //         time:'11月20日',
            //         thing:'水中银小鱼亲测与雅兰国际研发制造中心在大会现场签署了全面战略合作协议，启动绿鱼计划，与众多ODM、OEM品牌合作，推出了绿鱼配方'
            //     },
            //     {
            //         time:'11月20日',
            //         thing:'水中银小鱼亲测携手国内第一专业母婴垂直平台妈妈网签订战略合作签约仪式。未来双方旨在通过共推《绿鱼妈妈亲测榜》、技术合作、数据共享等持续深度合作，以更高标准为妈妈们甄选放心产品。1月初，水中银小鱼亲测与海外最佳亲子数码媒体《Oh!爸妈》推出「最高安全检测大奖」。'
            //     },
            //     {
            //         time:'11月20日',
            //         thing:'由中国美妆网主办、抖盟协办2019中国美妆网红选品大会，水中银小鱼亲测受邀成为支持单位，并举办中国好配方比赛。'
            //     }
                    
                
            // ],
            fishqcthings:this.$t("about.hugethings"),
            // powerdata:[
            //     {
            //         img:'http://p1.fishqc.net/FtwFhyy_XQehXoVOeTfS3JFfu9Cm',
            //         title:'中国香港总部',
            //         address:'全球实验中心总部'
            //     },
            //     {
            //         img:'http://p1.fishqc.net/Fm6wf8Otr9OXNFRmKDR24sXwbIjX',
            //         title:'比利时',
            //         address:'鲁汶大学授权实验室'
            //     },
            //     {
            //         img:'http://p1.fishqc.net/FhECEzkfKj5GkvNqZJL1VHJ6xtKw',
            //         title:'中国台湾',
            //         address:'Tentamus 腾德联合实验室'
            //     },
            //     {
            //         img:'http://p1.fishqc.net/FsrnKY-4Awn4AgrXHlUeeC0_ccDw',
            //         title:'上海',
            //         address:'东方美谷品质测评中心'
            //     }
            // ],
            powerdata:this.$t("about.powerdata"),
            powerdata1:this.$t("about.powerdata1"),
            currentlang:''
        }
        
    },
    computed: {
        swiper() {
            return this.$refs.order_report_Swiper.$swiper
        }
    },
    mounted() {
        var position  =  this.$route.query.position
        this.scrollTo(position)
        this.currentlang = window.localStorage.getItem("LOCALE") ||  'chs'
    },
    methods: {
        scrollTo(position){
            var that = this;
            var  scroll_H ;
            this.$nextTick(function(){
                if(position == 'greenrank'){
                    var d = document.getElementById("greenrank");
                    var topPos = d.offsetTop;
                    scroll_H = topPos - 110; //减去header高度
                }else{
                    scroll_H = this.$refs[position].offsetTop-110; //减去header高度
                }
                //全局方法
                that.scrollToY(scroll_H, 1500, 'easeInOutQuint');
            })
        },
    }
}
</script>